import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const NotificationModal = ({ 
  show, 
  onClose, 
  title, 
  message, 
  type = 'info', // 'success', 'error', 'warning', 'info', 'confirm'
  onConfirm = null,
  confirmText = 'Aceptar',
  cancelText = 'Cancelar',
  showCancel = false
}) => {
  const getIcon = () => {
    switch(type) {
      case 'success':
        return 'bi-check-circle-fill';
      case 'error':
        return 'bi-x-circle-fill';
      case 'warning':
        return 'bi-exclamation-triangle-fill';
      case 'confirm':
        return 'bi-question-circle-fill';
      default:
        return 'bi-info-circle-fill';
    }
  };

  const getColor = () => {
    switch(type) {
      case 'success':
        return { bg: '#d4edda', border: '#c3e6cb', text: '#155724', icon: '#28a745' };
      case 'error':
        return { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24', icon: '#dc3545' };
      case 'warning':
        return { bg: '#fff3cd', border: '#ffeaa7', text: '#856404', icon: '#ffc107' };
      case 'confirm':
        return { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460', icon: '#17a2b8' };
      default:
        return { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460', icon: '#17a2b8' };
    }
  };

  const colors = getColor();

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header 
        style={{ 
          background: colors.bg, 
          borderBottom: `2px solid ${colors.border}`,
          borderTopLeftRadius: 'calc(0.375rem - 1px)',
          borderTopRightRadius: 'calc(0.375rem - 1px)'
        }}
      >
        <Modal.Title style={{ color: colors.text, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <i className={`bi ${getIcon()}`} style={{ color: colors.icon, fontSize: '1.5rem' }}></i>
          {title || (type === 'confirm' ? 'Confirmar acción' : type === 'error' ? 'Error' : type === 'success' ? 'Éxito' : type === 'warning' ? 'Advertencia' : 'Información')}
        </Modal.Title>
        {!showCancel && (
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
            style={{ opacity: 0.7 }}
          ></button>
        )}
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <p style={{ margin: 0, color: '#495057', fontSize: '1rem', lineHeight: '1.6' }}>
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: `1px solid ${colors.border}`, background: '#f8f9fa' }}>
        {showCancel && (
          <Button variant="secondary" onClick={onClose}>
            {cancelText}
          </Button>
        )}
        <Button 
          variant={type === 'error' ? 'danger' : type === 'success' ? 'success' : type === 'warning' ? 'warning' : 'primary'}
          onClick={handleConfirm}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificationModal;

